var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'text-start ' + _vm.statusColor},[_c('b',[_vm._v(" "+_vm._s(_vm.$t(`call-reporting.table.call-statuses.${_vm.rowData.call_status}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }